export const products = [
  {
    id: 1,
    name: "Perro Suizo",
    price: 17000,
    category_Id: 1,
    category_Name: "Perros",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/perroSuizo.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/perroSuizo.webp",
    },
    ingredients: [
      "Pan Brioche de mantequilla",
      "Salchicha suiza",
      "Queso mozzarella",
      "Papa ripio",
      "Lechuga",
      "Salsa de la casa",
    ],
  },
  {
    id: 2,
    name: "ChoriPerro",
    price: 15000,
    category_Id: 1,
    category_Name: "Perros",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Choriperro_20240418_151123_0000.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Choriperro_20240418_151123_0000.webp",
    },
    ingredients: [
      "Pan Brioche de mantequilla",
      "Chorizo campesino",
      "Queso mozzarella",
      "Papa ripio",
      "Lechuga",
      "Salsa de la casa",
    ],
  },
  {
    id: 3,
    name: "ChoriPerro Artesanal",
    price: 18000,
    category_Id: 1,
    category_Name: "Perros",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Choriperro%20Artesanal_20240418_151454_0000.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Choriperro%20Artesanal_20240418_151454_0000.webp",
    },
    ingredients: [
      "Pan Brioche de mantequilla",
      "Chorizo Artesanal Santarosano",
      "Queso mozzarella",
      "Papa ripio",
      "Lechuga",
      "Salsa de la casa",
    ],
  },
  {
    id: 4,
    name: "Hamburguesa Tradicional",
    price: 18000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Hamburguesa%20Tradicional_20240418_150746_0000.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Hamburguesa%20Tradicional_20240418_150746_0000.webp",
    },
    ingredients: [
      "Pan Brioche de mantequilla",
      "Carne especial a la parrilla 125g",
      "Lechuga",
      "Pepino",
      "Tomate",
      "Queso mozzarella",
    ],
  },
  {
    id: 5,
    name: "Hamburguesa Santarosana",
    price: 23000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Hamburguesa%20Santarosana_20240418_151015_0000.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Hamburguesa%20Santarosana_20240418_151015_0000.webp",
    },
    ingredients: [
      "Pan Brioche",
      "Carne especial en salsa BBQ a la parrilla 125g",
      "Chorizo Santarosano",
      "Lechuga",
      "Pepino",
      "Tomate",
      "Queso mozzarella",
    ],
  },
  {
    id: 6,
    name: "Papas a la francesa",
    price: 4000,
    tamaño: "100 gr",
    category_Id: 4,
    category_Name: "Adiciones",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/papas%20a%20la%20francesa.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/papas%20a%20la%20francesa.webp",
    },
  },
  {
    id: 7,
    name: "Coca-cola personal",
    price: 4000,
    tamaño: "400ml",
    category_Id: 4,
    category_Name: "Adiciones",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/coca-cola%20400ml%20.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/coca-cola%20400ml%20.webp",
    },
  },
  {
    id: 8,
    name: "Manzana Postobon",
    tamaño: "400 ml",
    price: 3000,
    category_Id: 4,
    category_Name: "Adiciones",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/manzana%20400ml%20.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/manzana%20400ml%20.webp",
    },
  },
  {
    id: 9,
    name: "Doble Smash Cheeseburger",
    price: 18000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    ingredients: [
      "Pan Brioche de mantequilla",
      "Doble carne especial Smash 65g",
      "Extra queso mozzarella",
    ],
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Doble%20smash%20cheeseburger.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Doble%20smash%20cheeseburger.webp",
    },
  },
  {
    id: 10,
    name: "Sándwich Gourmet Pollo",
    price: 17000,
    category_Id: 3,
    category_Name: "Sándwiches Gourmet",
    ingredients: [
      "Pan Brioche de orégano",
      "Pechuga de pollo",
      "Jamón pietrán",
      "Lechuga",
      "Tomate",
      "Salsa de la casa",
    ],
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Sandwich.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Sandwich.webp",
    },
  },
  {
    id: 11,
    name: "Perro con todo",
    price: 20000,
    category_Id: 1,
    category_Name: "Perros",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Perro%20Con%20todo_20240418_150620_0000.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Perro%20Con%20todo_20240418_150620_0000.webp",
    },
    ingredients: [
      "Pan Brioche de mantequilla",
      "Chorizo campesino",
      "Butifarra Zenú",
      "Pechuga de pollo",
      "Lomo de cerdo",
      "Lechuga",
      "salsa de la casa",
    ],
  },
  {
    id: 12,
    name: "Sándwich Gourmet Cerdo",
    price: 17000,
    category_Id: 3,
    category_Name: "Sándwiches Gourmet",
    ingredients: [
      "Pan Brioche de orégano",
      "Lomo de cerdo",
      "Jamón pietrán",
      "Lechuga",
      "Tomate",
      "Salsa de la casa",
    ],
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Sandwich.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Sandwich.webp",
    },
  },
  {
    id: 13,
    name: "Doble Smash Cheeseburger a caballo",
    price: 19000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    ingredients: [
      "Pan Brioche de mantequilla",
      "Doble carne especial Smash 65g",
      "Extra queso mozzarella",
      "Huevo frito",
      "cebolla caramelizada",
    ],
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/SmashBurguer-a-Caballo.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/SmashBurguer-a-Caballo.webp",
    },
  },
  {
    id: 14,
    name: "Hamburguesa Doble Carne",
    price: 25000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/HamburguesaDobleCarne.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/HamburguesaDobleCarne.webp",
    },
    ingredients: [
      "Pan Brioche",
      "250g de Carne especial en salsa Chimichurri a la parrilla",
      "Lechuga",
      "Pepino",
      "Tomate",
      "Queso mozzarella",
      "Cebolla Caramelizada",
    ],
  },
  {
    id: 16,
    name: "Smash Bacon Cheeseburger",
    price: 20000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    ingredients: [
      "Pan Brioche de mantequilla",
      "Doble carne especial Smash 65g",
      "Extra queso mozzarella",
      "Tocineta ahumada",
      "cebolla caramelizada",
    ],
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Bacon-cheese-burguer.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Bacon-cheese-burguer.webp",
    },
  },
  /*
  {
    id: 17,
    name: "Combo Comparti2",
    price: 30000,
    category_Id: 2,
    category_Name: "Hamburguesas",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Combo%20Mini%20burguer.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Combo%20Mini%20burguer.webp",
    },
    ingredients: [
      "1 Mini-Hamburguesa Santarrosana",
      "1 Mini-Hamburguesa Cheese-Bacon",
      "2 Porciones de papas a la francesa",
    ],
  },
  */
  {
    id: 18,
    name: "Perrito burguer",
    description: "Fusión entre hamburguesa y perro caliente con carne especial de hamburguesa y butifarra.",
    price: 28000,
    category_Id: 2,
    category_Name: "Perros",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/perrito-burguer.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/perrito-burguer.webp",
    },
    ingredients: [
      "Pan perro",
      "120gr de carne especial de hamburguesa en chimichurri",
      "Butifarra",
      "Lechuga",
      "Papa fosforito",
      "Queso mozzarella",
      "Salsas",
    ],
  },
/*  {
    id: 19,
    name: "Hamburguesa Costeña",
    description: "Hamburguesa con queso costeño, patacón crocante y un toque caribeño.",
    price: 22000,
    category_Id: 1,
    category_Name: "Hamburguesas",
    images: {
      small: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Coste%C3%B1aBurguer.webp",
      large: "https://raw.githubusercontent.com/Eduardbarrios/tawenomen-/main/Optimized-img/Coste%C3%B1aBurguer.webp",
    },
    ingredients: [
      "Pan brioche",
      "Carne especial 120gr",
      "Queso mozzarella",
      "Queso costeño asado",
      "Tajadas maduras",
      "cebolla caramelizada",
      "Lechuga",
      "Tomate",
      "Salsas",
    ],
  },*/
];
